import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/home/header_features.svg'
import _imports_1 from '@/assets/images/home/header.svg'
import _imports_2 from '@/assets/images/clients/windows_black.svg'
import _imports_3 from '@/assets/images/clients/android_black.svg'
import _imports_4 from '@/assets/images/clients/ios_black.svg'
import _imports_5 from '@/assets/images/clients/mac_black.svg'


const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "col-md-9 col-lg-10 px-md-4 home-header-bg" }
const _hoisted_3 = { class: "container py-3 py-lg-5" }
const _hoisted_4 = { class: "row justify-content-lg-between" }
const _hoisted_5 = { class: "col-md-6 text-center text-lg-start py-3 home-text-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid my-4",
  "data-aos": "zoom-in",
  "data-aos-easing": "ease-in-out",
  "data-aos-duration": "2000",
  src: _imports_0,
  alt: "Benefit"
}, null, -1)
const _hoisted_7 = {
  class: "white-text",
  "data-aos": "zoom-out",
  "data-aos-easing": "ease-in-out",
  "data-aos-duration": "2000"
}
const _hoisted_8 = {
  class: "white-text mt-4",
  "data-aos": "zoom-in",
  "data-aos-easing": "ease-in-out",
  "data-aos-duration": "2000"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "btn-image-align-inline" }
const _hoisted_11 = { class: "hc7 white-text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-down-fill" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid mt-4",
    src: _imports_1,
    alt: "Benefit",
    "data-aos": "zoom-in-up",
    "data-aos-easing": "ease-in-out",
    "data-aos-duration": "3000"
  })
], -1)
const _hoisted_14 = {
  class: "container py-lg-5 my-lg-5 underline-container",
  ref: "download",
  id: "download"
}
const _hoisted_15 = { class: "row text-center" }
const _hoisted_16 = { class: "hc0 bold" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1)
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "col-md-12 text-center text-lg-start pt-5" }
const _hoisted_20 = { class: "container-fluid bg-platform-bg" }
const _hoisted_21 = { class: "container mt" }
const _hoisted_22 = { class: "row d-flex justify-content-between p-3 align-items-center" }
const _hoisted_23 = {
  class: "col-6 col-md-2 col-lg-2 p-4 download-box",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-easing": "ease-in-sine"
}
const _hoisted_24 = { class: "p-2 bd-highlight text-center imageBox" }
const _hoisted_25 = {
  class: "link-icon",
  href: "/tutorials/windows?d=y&p=2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "img-fluid hoverImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "img-fluid mainImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_28 = {
  class: "col-6 col-md-2 col-lg-2 p-4 download-box",
  "data-aos": "fade-down",
  "data-aos-offset": "300",
  "data-aos-easing": "ease-in-sine"
}
const _hoisted_29 = { class: "p-2 bd-highlight text-center imageBox" }
const _hoisted_30 = {
  class: "link-icon active-link",
  href: "/tutorials/android?d=y&p=2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "img-fluid hoverImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "img-fluid mainImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_33 = {
  class: "col-6 col-md-2 col-lg-2 p-4 download-box",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-easing": "ease-in-sine"
}
const _hoisted_34 = { class: "p-2 bd-highlight text-center imageBox" }
const _hoisted_35 = {
  class: "link-icon",
  href: "/tutorials/ios?p=2"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "img-fluid hoverImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "img-fluid mainImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_38 = {
  class: "col-6 col-md-2 col-lg-2 p-4 download-box",
  "data-aos": "fade-down",
  "data-aos-offset": "300",
  "data-aos-easing": "ease-in-sine"
}
const _hoisted_39 = { class: "p-2 bd-highlight text-center imageBox" }
const _hoisted_40 = {
  class: "link-icon",
  href: "/tutorials/ios?p=2"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img-fluid hoverImg mb-3",
  alt: "download icon"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img-fluid mainImg mb-3",
  alt: "download icon"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h1", _hoisted_7, _toDisplayString($setup.locale.home10), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.locale.home11), 1),
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.downloadFile())),
              class: "hvr-wobble-vertical btn-1 mt-3 px-4"
            }, [
              _createElementVNode("img", {
                class: "img-fluid mx-2",
                width: "32",
                height: "32",
                src: $setup.data.clientOSImage,
                alt: "client"
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString($setup.data.clientOS), 1),
                _createElementVNode("span", _hoisted_11, _toDisplayString($setup.locale.home12), 1)
              ])
            ]),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.scrollTo('download'))),
              class: "hvr-wobble-vertical btn-2 mt-3 white-text pt20"
            }, [
              _createTextVNode(_toDisplayString($setup.locale.home13), 1),
              _hoisted_12
            ])
          ]),
          _hoisted_13
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, [
          _createTextVNode(_toDisplayString($setup.locale.home14), 1),
          _hoisted_17
        ]),
        _createElementVNode("span", _hoisted_18, _toDisplayString($setup.locale.home17), 1),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("a", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("h5", null, _toDisplayString($setup.locale.home18), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("a", _hoisted_30, [
                      _hoisted_31,
                      _hoisted_32,
                      _createElementVNode("h5", null, _toDisplayString($setup.locale.home19), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("a", _hoisted_35, [
                      _hoisted_36,
                      _hoisted_37,
                      _createElementVNode("h5", null, _toDisplayString($setup.locale.home20), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("a", _hoisted_40, [
                      _hoisted_41,
                      _hoisted_42,
                      _createElementVNode("h5", null, _toDisplayString($setup.locale.home21), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ]))
}